import { ScheduleOrg } from '@wetags/schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useGetReschedulingRulesAccess = () => {
  const { isScheduleV3FlagEnabled, isLoading: isLoadingV3Flag } =
    SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const [isReschedulingRulesEnabled, isLoadingRulesWetag] = ScheduleOrg.useWetag('rescheduling-rules');

  const isLoading = isLoadingV3Flag || isLoadingRulesWetag;

  const access = isScheduleV3FlagEnabled && isReschedulingRulesEnabled;

  const hasReschedulingRulesAccess = isLoading ? false : access;

  return {
    isLoading,
    hasReschedulingRulesAccess,
  };
};
